<template lang="pug">
  lei-modal.periods-modal(@close="toggleModal(false)" :title="title" size="md" :close-with-overlay="false")
    challenge-compare-block(
      :value="startDate"
      :jsonPath="startDatePath"
      :oldValue="startDateValue"
      @change="value => setNewValue('startDate', value)"
      label="Propose Period Start Date"
      labelForOld="Old Period Start Date")

    challenge-compare-block(
      :value="endDate"
      :jsonPath="endDatePath"
      :oldValue="endDateValue"
      @change="value => setNewValue('endDate', value)"
      label="Propose Period End Date"
      labelForOld="Old Period End Date")

    comment-input(@input="comment=$event")
    div(slot="footer")
      lei-btn(type="cyprus" fill @click="save" :disabled="disabled") Save
</template>

<script>
import { mapState, mapMutations, mapActions, } from 'vuex'
import { TOGGLE_CHALLENGE_PERIODS, SAVE_FIELD, } from '@/store/modules/record/modules/challenge/mutations-types'
import { getFieldIdByPath, } from '@/utils/challenge'

import ChallengeCompareBlock from '@/components/challenge-components/ChallengeCompareBlock'
import CommentInput from '@/components/lei-components/inputs/CommentInput'
import LeiModal from '@/components/lei-components/LeiModal'
import LeiBtn from '@/components/lei-components/LeiBtn'

export default {
  name: 'ChallengePeriodsModal',
  components: {
    ChallengeCompareBlock,
    CommentInput,
    LeiModal,
    LeiBtn,
  },
  data () {
    return {
      type: '',
      startDate: '',
      endDate: '',
      comment: {
        value: '',
        valid: true,
      },
    }
  },
  computed: {
    title () {
      return `Challenge: ${this.challengePeriods.title}`
    },
    noChanges () {
      return this.parentType && Boolean(this.startDate)
          || this.parentType && Boolean(this.endDate)
    },
    disabled () {
      return !this.comment.valid || !this.noChanges
    },
    rootPath () {
      return this.parentType + 'Parent'
    },
    typePath () {
      return this.getJsonPath('type')
    },
    startDatePath () {
      return this.getJsonPath('startDate')
    },
    endDatePath () {
      return this.getJsonPath('endDate')
    },
    typeValue () {
      return this.getValue('type')
    },
    startDateValue () {
      return this.getValue('startDate')
    },
    endDateValue () {
      return this.getValue('endDate')
    },
    ...mapState('record/challenge', [ 'challengePeriods', 'parentType', ]),
  },
  methods: {
    toggleModal () {
      this.toggleChallengePeriodsModal(false)
    },
    setNewValue (property, value) {
      this[property] = value
    },
    getJsonPath (prop) {
      return this.challengePeriods[prop].jsonPath
    },
    getValue (prop) {
      return this.challengePeriods[prop].value
    },
    async save () {
      let fieldsToProcess = [
        {
          value: this.type,
          originValue: this.typeValue,
          jsonPath: this.typePath,
        },
        {
          value: this.startDate,
          originValue: this.startDateValue,
          jsonPath: this.startDatePath,
        },
        {
          value: this.endDate,
          originValue: this.endDateValue,
          jsonPath: this.endDatePath,
        },
      ]

      await this.processChallengeChanges(fieldsToProcess)
      this.toggleChallengePeriodsModal()
    },
    async processChallengeChanges (fieldsToProcess) {
      for (const fieldToProcess of fieldsToProcess) {
        let { jsonPath, } = fieldToProcess
        let originalValue = fieldToProcess.originValue || null
        let proposedValue = fieldToProcess.value
        const comment = `${this.typeValue}
        ${this.comment.value}`

        if (proposedValue) {
          const { xpath, } = await this.getField(getFieldIdByPath(jsonPath))
          this.saveField({
            original_value: originalValue,
            proposed_value: proposedValue,
            comment: comment,
            field: xpath,
            jsonPath: jsonPath,
          })
        }
      }
    },

    ...mapMutations('record/challenge', {
      toggleChallengePeriodsModal: TOGGLE_CHALLENGE_PERIODS,
      saveField: SAVE_FIELD,
    }),
    ...mapActions('record/challenge', [ 'getField', ]),
  },
}
</script>

<style scoped lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/modals/ChallengePeriodsModal.vue